import axios from "axios";

import { CommisionProps } from "../../Commission";
import { restErrorHandler } from '../../../../helpers/restErrorHandler';
import { RestApiState } from "../../Organization";
import { getCsrftoken } from "../../../../helpers/csfrToken";


export const updateCommissionData = (serialNumber: string, role: string, data: any, statusSetter: (value: RestApiState) => void): void => {
    const headers = {
        headers: {
            'X-CSRFToken': getCsrftoken(),
            'Content-Type': 'multipart/form-data'
        },
        withCredentials: true        
    }
    axios.put<CommisionProps>(`${process.env.REACT_APP_DJANGO_SERVER_URL}/api/${role}/v2/acb/${serialNumber}/commission`, data , headers)
        .then(response => {
                if (response.status === 200) {
                    statusSetter(RestApiState.Success)
                }
            }
        )
        .catch(error => {
            console.error('Error fetching accumulator details:', error)
            if (error.response.status === 400) {
                statusSetter(RestApiState.BadRequest)
            } else if (error.response.status === 500) {
                statusSetter(RestApiState.ServerError)
            } else {
                statusSetter(RestApiState.Unknown)
            }
        });
}